"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chieti": {
    "403f5aad": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-marfisi": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "ac2086b0": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "04305b85": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "filippone": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "d53f7914": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-degli-angeli": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "72d1ca13": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-delle-piane": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "349cb0ab": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "475fa321": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "pietragrossa": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "217ebb8e": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "s-anna": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "4a93e2ee": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "s-martino": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "8c784c7d": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "c44f81ef": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "stadio": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "9f11de50": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "482d0a3a",
      "slug": "chieti-scalo",
      "name": "Chieti Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7211f616": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "v-europa": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "d9b754e3": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "v-le-amendola": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "a6685d6a": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "via-liberazione": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }],
    "fb7bac7f": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "skipSearch": false
    }],
    "zona-levante": [{
      "hkey": "e05ba4b6",
      "slug": "chieti-citta",
      "name": "Chieti Città",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chieti"
    }]
  }
};
exports["default"] = _default;